export default __webpack_public_path__ + "static/media/collaboration.0f510597.svg";